import gql from 'graphql-tag';
import { clients } from '../../../util/clients';
import { fieldsToGqlString, mergeByIdNewAtTop } from '../../../util/shared/vue-global';

const { backend } = clients.direct;

const fieldsOfMiscMtg = {
  _id: '',
  fromDate: '',
  toDate: '',
  totalMtgTax: '',
  totalCertFees: '',
  totalMisc: '',
  jointMill: '',
  mvTaxStamps: '',
  alcoholicBevTax: '',
  motorVechicle: '',
  apportionLikeTaxes: '',
  totalofSpecialApportionment: '',
  otherADA: '',
  otherCensus: '',
  isLocked: '',
  status: '',
  floodControl: '',
  interestFourMill: '',
  divideByADA: '',
  divideByCensus: '',
};

export const apprMiscMtg = {
  namespaced: true,
  state: () => ({
    apportionmentMiscMtgItems: [],
    isLockedRecordAvailable: false,
  }),
  mutations: {
    setApportionmentMiscMtgItems(state, items) {
      state.apportionmentMiscMtgItems = items;
    },
    setisLockedRecordAvailable(state, item) {
      state.isLockedRecordAvailable = item;
    },
  },
  actions: {
    async loadApportionmentMiscMtgRecords({ commit, dispatch }, { criteria, baseCrudKey }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql` query apportionmentMiscMtg($criteria: apportionmentMiscMtgCriteriaType) {
            apportionmentMiscMtg(criteria: $criteria) {
              ${fieldsToGqlString(fieldsOfMiscMtg)},
              }
            }`,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);

        if (results.data) {
          const apportionmentMiscMtgData = results.data.apportionmentMiscMtg;
          if (baseCrudKey === 'apportionment') {
            const mtgCodes = [];
            for (const item of apportionmentMiscMtgData) {
              mtgCodes.push(item.mtgCode);
            }
            commit('setReportDatastateItems', mtgCodes);
          } else {
            commit('base/crud/setItems', [baseCrudKey, apportionmentMiscMtgData], { root: true });
          }
        }
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem getting misc-mtg records.', { root: true });
      }
    },
    async loadApportionmentMiscMtgBuildRecords({ commit, dispatch }, { criteria, baseCrudKey }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql` query apportionmentMiscMtgBuildRecord($criteria: apportionmentMiscMtgCriteriaType) {
            apportionmentMiscMtgBuildRecord(criteria: $criteria) {
              ${fieldsToGqlString(fieldsOfMiscMtg)},
              }
            }`,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);

        if (results.data) {
          const buildrecord = { ...results.data.apportionmentMiscMtgBuildRecord };
          commit('base/crud/setItem', [baseCrudKey, buildrecord], { root: true });
        }
        return results.data.apportionmentMiscMtgBuildRecord;
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem getting Mortgage-Codes-List.', { root: true });
      }
      return [];
    },
    async upsertMiscMtgRecord({ dispatch, rootGetters, commit }, {
      item, baseCrudKey,
    }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation upsertApportionmentMiscMtg ($item: apportionmentMiscMtgInputType!)  {
            upsertApportionmentMiscMtg(upsert: $item) {
                    ${fieldsToGqlString(fieldsOfMiscMtg)},
                  }
                }`,
          variables: {
            item,
          },
        });
        clients.handleGQLErrors(results, commit);
        const MiscMtgApportionmentTransStateData = rootGetters['base/crud/items'](baseCrudKey);
        const newTransaction = results.data ? (results.data.upsertApportionmentMiscMtg
            || {}) : {};
        const newList = mergeByIdNewAtTop(MiscMtgApportionmentTransStateData || [], newTransaction);
        commit('base/crud/setItems', [baseCrudKey, newList], { root: true });
        return newTransaction;
      } catch (e) {
        // Check if this is a GL fund validation error
        const errorMessage = e.message || '';
        const isGLFundError = errorMessage.includes('Section field, GL fund missing in the record')
                             || errorMessage.includes('VALIDATION_ERROR');

        if (isGLFundError) {
          // Extract record data if available
          let errorData = null;
          let headline = null;
          try {
            if (e.graphQLErrors && e.graphQLErrors.length > 0) {
              const gqlError = e.graphQLErrors[0];
              if (gqlError.message) {
                const parsedMessage = JSON.parse(gqlError.message);
                // Handle new structure with invalidRecords or fallback to old recordData
                errorData = parsedMessage.invalidRecords ? parsedMessage : parsedMessage.recordData;
                headline = parsedMessage.message;
              }
            }
          } catch (parseError) {
            console.warn('Could not parse error record data:', parseError);
          }

          // Throw a specific error that the component can catch
          const glFundError = new Error('VALIDATION_ERROR');
          glFundError.recordData = errorData;
          glFundError.headline = headline;
          glFundError.originalError = e;
          throw glFundError;
        }

        // dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        // Missing/mismatched setup arrives here with a message listing every record to fix; nothing was rebuilt.
        const setupMessage = e.graphQLErrors && e.graphQLErrors[0] && e.graphQLErrors[0].message;
        if (setupMessage && /cannot be built|does not add up/.test(setupMessage)) {
          alert(setupMessage);
        } else {
          dispatch('flashError', 'There was a problem in upserting the transaction!', { root: true });
        }
      }
      return {};
    },
    async checkForLockedRecords({ commit, dispatch }, { criteria }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql` query checkLockedRecords($criteria: apportionmentMiscMtgCriteriaType) {
            checkLockedRecords(criteria: $criteria) {
              isLockedRecordAvailable,
              }
            }`,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        const result = results.data ? (results.data.checkLockedRecords || 0) : {};
        commit('setisLockedRecordAvailable', result.isLockedRecordAvailable);
        return result;
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem getting Mortgage-Codes-List.', { root: true });
      }
      return null;
    },
  },
};

export default apprMiscMtg;
